document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initTabsComparativa();
  initFaq();
  initAntesDespues();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var target = parseFloat(el.getAttribute('data-mt-contador')) || 0;
        var suffix = el.getAttribute('data-mt-sufijo') || '';
        if (reduced) { el.textContent = target + suffix; return; }
        var start = null;
        var duration = 1400;
        function paso(ts) {
          if (!start) start = ts;
          var progreso = Math.min((ts - start) / duration, 1);
          var facilitado = 1 - Math.pow(1 - progreso, 3);
          var valor = Math.round(target * facilitado);
          el.textContent = valor + suffix;
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initTabsComparativa() {
  var wrap = document.querySelector('[data-mt-comparativa]');
  if (!wrap) return;
  var botones = wrap.querySelectorAll('[data-mt-tab]');
  var paneles = wrap.querySelectorAll('[data-mt-panel]');
  botones.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-mt-tab');
      botones.forEach(function (b) { b.classList.remove('mt-tab-activo'); });
      paneles.forEach(function (p) {
        p.classList.toggle('mt-visible-panel', p.getAttribute('data-mt-panel') === id);
      });
      btn.classList.add('mt-tab-activo');
    });
  });
}

function initAntesDespues() {
  var sliders = document.querySelectorAll('[data-mt-antesdespues]');
  if (!sliders.length) return;

  sliders.forEach(function (slider) {
    var recorte = slider.querySelector('[data-mt-ad-recorte]');
    var manija = slider.querySelector('[data-mt-ad-manija]');
    if (!recorte || !manija) return;

    var inicio = parseFloat(slider.getAttribute('data-mt-inicio')) || 50;
    aplicarPosicion(inicio);

    var arrastrando = false;

    function posicionDesdeEvento(evento) {
      var rect = slider.getBoundingClientRect();
      var x = evento.clientX - rect.left;
      var porcentaje = (x / rect.width) * 100;
      return Math.min(100, Math.max(0, porcentaje));
    }

    function aplicarPosicion(porcentaje) {
      recorte.style.clipPath = 'inset(0 ' + (100 - porcentaje) + '% 0 0)';
      manija.style.left = porcentaje + '%';
    }

    manija.addEventListener('pointerdown', function (evento) {
      arrastrando = true;
      manija.setPointerCapture(evento.pointerId);
    });
    manija.addEventListener('pointermove', function (evento) {
      if (!arrastrando) return;
      aplicarPosicion(posicionDesdeEvento(evento));
    });
    manija.addEventListener('pointerup', function () { arrastrando = false; });
    manija.addEventListener('pointercancel', function () { arrastrando = false; });

    slider.addEventListener('pointerdown', function (evento) {
      if (evento.target === manija || manija.contains(evento.target)) return;
      aplicarPosicion(posicionDesdeEvento(evento));
    });

    manija.addEventListener('keydown', function (evento) {
      var actual = parseFloat(manija.style.left) || inicio;
      if (evento.key === 'ArrowLeft') { aplicarPosicion(Math.max(0, actual - 5)); }
      if (evento.key === 'ArrowRight') { aplicarPosicion(Math.min(100, actual + 5)); }
    });
  });
}

function initFaq() {
  var items = document.querySelectorAll('[data-mt-faq-item]');
  if (!items.length) return;
  items.forEach(function (item) {
    var pregunta = item.querySelector('[data-mt-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierta = item.classList.contains('mt-faq-abierta');
      items.forEach(function (i) { i.classList.remove('mt-faq-abierta'); });
      if (!abierta) item.classList.add('mt-faq-abierta');
    });
  });
}
